import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'
import classNames from "classnames";
import { path } from 'Constants'
import moment from 'moment'
import {ControlTextE} from 'UI/CustomComponents/Controls';
// Actions
import {
    getFlightPlanningDocParameters,
    updateFlightPlanningDocParameters,
    resetError
} from 'actions/spendActions'

// Utils
import { BreakLine } from 'utils/Utils'

class FlightPlanningDocParameters extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            flightPlanningDocParameters: [],
            editedDocParameters: [],
            respnseMessage: '',
            isError: false
        }
        this.loadData = this.loadData.bind(this)
        this.trackDocParameterChanges = this.trackDocParameterChanges.bind(this)
        this.onDocParameterSave = this.onDocParameterSave.bind(this)
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        this.getAllParameters();
    }

    trackDocParameterChanges(record) {
        if (this.state.editedDocParameters.length === 0 || this.state.editedDocParameters.find(a => a.DOC_ID === record.DOC_ID) === undefined) {
            var updatedRecords = this.state.editedDocParameters
            updatedRecords.push(record)
            this.setState({ respnseMessage: '', editedDocParameters: updatedRecords, isError: false })
        }
    }

    getAllParameters() {
        this.setState({ isLoading: true, respnseMessage: '', isError: false });
        this.props.getFlightPlanningDocParameters().then((response) => {
            if (response.status === 200) {
                this.setState({ flightPlanningDocParameters: response.data.Result, isLoading: false, respnseMessage: '', isError: false });
            }
            else {
                this.setState({ isLoading: false, respnseMessage: this.props.content.errorMessage, isError: true });
            }
        }).catch((error) => {
            this.setState({ isLoading: false, respnseMessage: this.props.content.errorMessage, isError: true });
        })
    }

    onDocParameterSave() {
        if (this.state.editedDocParameters.find(a => a.MIN_DOC === '') === undefined && this.state.editedDocParameters.find(a => a.MAX_DOC === '') === undefined && this.state.editedDocParameters.find(a => a.DOC_SEGMENTATION === '') === undefined) {
            if (this.state.editedDocParameters.find(a => a.MIN_DOC === '-') === undefined && this.state.editedDocParameters.find(a => a.MAX_DOC === '-') === undefined) {
                if (this.state.editedDocParameters.find(a => Number(a.MAX_DOC) > 999999999) !== undefined) {
                    this.setState({ respnseMessage: this.props.content.maxDocLimit, isError: true });
                }
                else if (this.state.editedDocParameters.find(a => Number(a.MIN_DOC) < 0) !== undefined) {
                    this.setState({ respnseMessage: this.props.content.minDocLimit, isError: true });
                }
                else {
                    this.setState({ isLoading: true, respnseMessage: '', isError: false });
                    let email = this.props.user.user.Email
                    let updatedRecords = this.state.editedDocParameters.map(item => ({ ...item }))
                    updatedRecords.map(function (parameter) {
                        parameter['UPDATED_BY'] = email
                    });
                    this.props.updateFlightPlanningDocParameters(updatedRecords).then((response) => {
                        if (response.status === 200) {
                            // this.state.flightPlanningDocParameters.map(function (parameter) {
                            //     if (updatedRecords.find(a => a.DOC_ID === parameter.DOC_ID))
                            //         parameter['UPDATED_BY'] = email
                            // });
                            this.setState({ flightPlanningDocParameters: response.data.Result, editedDocParameters: [], isLoading: false, respnseMessage: this.props.content.successMessage, isError: false });
                        }
                        else {
                            this.setState({ isLoading: false, respnseMessage: this.props.content.errorMessage, isError: true });
                        }
                    }).catch((error) => {
                        this.setState({ isLoading: false, respnseMessage: this.props.content.errorMessage, isError: true });
                    })
                }
            }
            else {
                this.setState({ respnseMessage: this.props.content.validNumber, isError: true });
            }
        }
        else {
            this.setState({ respnseMessage: this.props.content.blankValue, isError: true });
        }
    }

    componentWillUnmount() {
        this.props.resetError()
    }

    render() {
        var _instance = this
        var docParameters = this.state.flightPlanningDocParameters.map(function (parameter) {
            return (<TableRows
                docParameter={parameter}
                trackDocParameterChanges={_instance.trackDocParameterChanges}
                readOnly={_instance.props.readOnly}
            />
            );
        });

        return (
            <div>
                <div>
                    <div className="grid-x">
                        <div className="medium-12">
                            <div>
                                {(this.state.isLoading) ?
                                    <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                        src={path + `images/ajax-loader.gif`} alt="" />
                                    : null
                                }
                            </div>
                            {this.state.flightPlanningDocParameters.length > 0 ?
                                <div>
                                    <div className="grid-x">
                                        <div className="medium-3 float-left" style={{ fontSize: '1.2rem', paddingBottom: '8px' }}>{BreakLine(this.props.content.docParameters)}</div>
                                        <div className="medium-6" style={{ display: 'flex', justifyContent: 'center' }} >
                                            {this.state.isError ?
                                                <div style={{ margin: '0 0 0.5rem', color: 'red' }}>{this.state.respnseMessage}</div> :
                                                <div style={{ margin: '0 0 0.5rem', color: '#4fb81c' }}>{this.state.respnseMessage}</div>
                                            }
                                        </div>
                                        <div className="medium-3"></div>
                                    </div>
                                    <div className="grid-x">
                                        <div className="medium-11 float-left" style={{ paddingBottom: '8px' }}>{this.props.content.docDescription}</div>
                                        {this.props.user.userprofile.Roles[0].indexOf("Admin") > -1 ?
                                            <div className="medium-1" style={{ paddingBottom: '2px' }} >
                                                <button className={classNames('float-right',
                                                    {
                                                        'hand-cursor': this.state.isLoading ? false : (this.state.editedDocParameters.length > 0),
                                                        'gray-scale': this.state.isLoading ? true : (this.state.editedDocParameters.length === 0)
                                                    })}
                                                    onClick={this.onDocParameterSave} disabled={this.state.isLoading ? true : this.state.editedDocParameters.length === 0} type="submit" float >
                                                    <img width="25" title={this.props.content.save} src="images/save_active.svg" />
                                                </button>
                                            </div> : null}
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                    {this.state.flightPlanningDocParameters.length > 0 ?
                        <div className="grid-x">
                            <div className="medium-12">
                                <Form
                                    model="flightPlanningDocParameter"
                                >
                                    <div className="grid-x basic-table">
                                        <table>
                                            <thead>
                                                <tr className="eachRow">
                                                    <th>{this.props.content.minDoc}</th>
                                                    <th>{this.props.content.maxDoc}</th>
                                                    <th>{this.props.content.docSegmentation}</th>
                                                    <th>{this.props.content.updatedBy}</th>
                                                    <th>{this.props.content.updatedOn}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {docParameters}
                                            </tbody>
                                        </table>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        : null}
                </div>
            </div>
        )
    }
}

class TableRows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //parameter: this.props.docParameter,
        };
    }

    onChangeEvent(val) {
        if (val.target.id === 'DOC_SEGMENTATION' || val.target.value === ''
            || /^(\-(\d*))$/.test(val.target.value) || !isNaN(val.target.value)) {
            var editingRow = this.props.docParameter;
            if (val.target.id === 'DOC_SEGMENTATION') {
                editingRow[val.target.id] = val.target.value
                this.props.trackDocParameterChanges(editingRow)
            }
            else {
                let editedValue = val.target.value.trim()
                if (editedValue.toString() !== editingRow[val.target.id].toString()) {
                    editingRow[val.target.id] = editedValue
                    this.props.trackDocParameterChanges(editingRow)
                }
            }
        }
    }

    render() {
        var bindValues = this.props.docParameter;
        return (
            <tr className="eachRow">
                <td>
                    <ControlTextE
                        model="flightPlanningDocParameter.MIN_DOC"
                        onChange={this.onChangeEvent.bind(this)}
                        id={'MIN_DOC'}
                        defaultValue={bindValues.MIN_DOC}
                        value={bindValues.MIN_DOC}
                        type='name'
                        className="edit-textarea"
                        readOnly={this.props.readOnly}
                    />
                </td>
                <td>
                    <ControlTextE
                        model="flightPlanningDocParameter.MAX_DOC"
                        onChange={this.onChangeEvent.bind(this)}
                        id={'MAX_DOC'}
                        defaultValue={bindValues.MAX_DOC}
                        value={bindValues.MAX_DOC}
                        type='name'
                        className="edit-textarea"
                        readOnly={this.props.readOnly}
                    />
                </td>
                <td>
                    <ControlTextE
                        model="flightPlanningDocParameter.DOC_SEGMENTATION"
                        onChange={this.onChangeEvent.bind(this)}
                        id={'DOC_SEGMENTATION'}
                        defaultValue={bindValues.DOC_SEGMENTATION}
                        value={bindValues.DOC_SEGMENTATION}
                        type='name'
                        className="edit-textarea"
                        readOnly={this.props.readOnly}
                    />
                </td>
                <td model="flightPlanningDocParameter.UpdatedBy">{bindValues.UPDATED_BY}</td>
                <td model="flightPlanningDocParameter.UpdatedOn">{moment(bindValues.UPDATED_ON).format('L')}</td>
            </tr>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        ui: state.content.ui,
        user: state.default,
        content: state.content.menu.EnablementParametersManager[0].MatchAndSegmentationTab.FlightPlanningDocDetails
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        getFlightPlanningDocParameters: () => dispatch(getFlightPlanningDocParameters()),
        updateFlightPlanningDocParameters: (records, userId) => dispatch(updateFlightPlanningDocParameters(records, userId)),
        resetError: () => dispatch(resetError())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightPlanningDocParameters)